import { render, staticRenderFns } from "./AreYouSure.vue?vue&type=template&id=c8963d6c&scoped=true&"
import script from "./AreYouSure.vue?vue&type=script&lang=js&"
export * from "./AreYouSure.vue?vue&type=script&lang=js&"
import style0 from "./AreYouSure.vue?vue&type=style&index=0&id=c8963d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8963d6c",
  null
  
)

export default component.exports